export default {
  0: '指定なし',
  1: '禁煙',
  2: '喫煙',
  3: '分煙',
}
